import type { JsonDataItem } from '../generic-types';
import clsx from 'clsx';
import DataGridCellSelector from './data-grid-cell-selector.component';
import type { DataGridCellRenderer } from './data-grid-custom-column.interface';
import type { DataGridColumnSettings } from './data-grid-settings.interface';
import { useRef } from 'react';

export interface DataGridDataRowItemProps {
  item: JsonDataItem;
  column: DataGridColumnSettings;
  components?: Record<string, DataGridCellRenderer>;
  allowCellScrollBar?: boolean;
}

export default function DataGridDataRowItem({
  item,
  column,
  components,
  allowCellScrollBar,
}: DataGridDataRowItemProps) {
  const ref = useRef<HTMLDivElement>(null);
  // NOTE: if modifying the margin 'odin-mr-3', please remember to update 'CELL_RIGHT_MARGIN_PX'
  const cellClasses = clsx('odin-box-content odin-mr-3', {
    'odin-h-9 odin-truncate odin-py-px odin-leading-9': !allowCellScrollBar,
    'odin-h-auto odin-leading-none odin-overflow-y-auto odin-content-center': allowCellScrollBar,
  });

  return (
    <div style={{ width: column.width + 'px' }} className={cellClasses}>
      <DataGridCellSelector
        ref={ref}
        item={item}
        column={column}
        components={components}
        allowCellScrollBar={allowCellScrollBar}
      />
    </div>
  );
}
